import rest from "@/rest-client";

export default {
  moduleName: "localization",
  namespaced: true,

  state: () => ({
    timezones: undefined,
    languages: [
      {
        flag: require("@/assets/images/flags/tr.jpg"),
        language: "tr",
        title: {
          tr: "Türkçe",
          en: "Turkish",
          fr: "Turkish",
          de: "Turkish",
        },
      },
      {
        flag: require("@/assets/images/flags/us.jpg"),
        language: "en",
        title: {
          tr: "İngilizce",
          en: "English",
          fr: "English",
          de: "English",
        },
      },
      // {
      //   flag: require("@/assets/images/flags/de.jpg"),
      //   language: "de",
      //   title: {
      //     tr: "Almanca",
      //     en: "German",
      //     fr: "German",
      //     de: "Deutsch",
      //   },
      // },
      //kullanılmadığı için şimdilik kaldırıldı
      // {
      //   flag: require("@/assets/images/flags/fr.jpg"),
      //   language: "fr",
      //   title: {
      //     tr: "Fransızca",
      //     en: "French",
      //     fr: "Français",
      //     de: "French",
      //   },
      // },
    ],
  }),
  getters: {
    languages: (state) => state.languages,
    timezones: (state) => state.timezones,
  },

  mutations: {
    timezones: (state, value) => (state.timezones = value),
  },

  actions: {
    async fetchTimezones({ commit }) {
      const response = await rest.get("/timezone");
      commit("timezones", response.data);

      return response;
    },
  },
};
